import React from 'react'
import withIconStyles from '@edulastic/icons/src/HOC/withIconStyles'
import SVG from '@edulastic/icons/src/common/SVG'

const IconAlignRight = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="15.518"
    height="12.192"
    viewBox="0 0 15.518 12.192"
    {...props}
  >
    <g transform="translate(0 -54.817)">
      <g transform="translate(0 54.817)">
        <path
          d="M14.963,383.721H.554a.533.533,0,0,0-.39.165.533.533,0,0,0-.164.39v1.108a.533.533,0,0,0,.165.39.534.534,0,0,0,.39.164H14.963a.562.562,0,0,0,.554-.554v-1.108a.562.562,0,0,0-.554-.554Z"
          transform="translate(0 -373.746)"
        />
        <path
          d="M121.274,274.088H110.19a.562.562,0,0,0-.554.554v1.108a.562.562,0,0,0,.554.554h11.084a.562.562,0,0,0,.554-.554v-1.108a.562.562,0,0,0-.554-.554Z"
          transform="translate(-106.311 -267.438)"
        />
        <path
          d="M50.4,164.456H37.1a.562.562,0,0,0-.554.554v1.108a.562.562,0,0,0,.554.554H50.4a.562.562,0,0,0,.554-.554V165.01a.562.562,0,0,0-.554-.554Z"
          transform="translate(-35.439 -161.131)"
        />
        <path
          d="M157.1,54.982a.533.533,0,0,0-.39-.165h-9.975a.562.562,0,0,0-.554.554V56.48a.562.562,0,0,0,.554.554h9.975a.562.562,0,0,0,.554-.554V55.371A.533.533,0,0,0,157.1,54.982Z"
          transform="translate(-141.747 -54.817)"
        />
      </g>
    </g>
  </SVG>
)

export default withIconStyles(IconAlignRight)
